<template>
  <div>
    <v-row no-gutters justify="space-between">
      <PageTitle :title="$gettext('Subscriptions')" />
    </v-row>
    <div v-if="listFollow.length !== 0">
      <v-row no-gutters class="py-2">
        <v-col
          :md="6"
          cols="12"
          class="py-4 px-md-8 px-4 boxRelative white rounded"
        >
        <v-row no-gutters align-center justify-center>
          <v-col
            cols="12"
            v-for="(val, i) in listFollow"
            :key="i"
            class="my-3"
          >
            <div class="d-flex align-center flex-wrap">
              <AvatarComponent size="66" :url="val.entityDetail.picture" />
              <v-btn
                plain
                :to="val.entityName == 'user' ? {
                  name: 'profilePerson',
                  params: { key: val.entityId }
                } : {
                  name: 'courses.home',
                  params: {
                  coursesCountry: val.entityDetail.country.slug,
                  namegolf: val.entityDetail.slug,
                  }
                }"
              >
                <span class="text-body-2 font-weight-bold boxRelative-name text-capitalize black--text">
                  {{ val.entityDetail.name }}
                </span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        </v-col>
        <v-col :md="6" cols="12"></v-col>
      </v-row>
      <InfiniteLoad
        v-if="currentPage > totalPages"
        @loading="onLoadCourse"
        :disabled="endData"
      />
    </div>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
export default {
  name: "Subscriptions",
  components: { PageTitle, InfiniteLoad },
  data() {
    return {
      endData: false,
      listFollow: [],
      currentPage: 1,
      totalPages: 1,
    };
  },
  props: {
    user: {
      type: Object,
    },
  },
  computed: {},
  methods: {
    async onLoadCourse() {
      this.currentPage += 1;
      this.getSubscription(this.currentPage);
    },
    async getSubscription() {
      const data = {
        userId: this.user.id,
        page: this.currentPage,
        limit: 10,
      };
      let result = await this.$store.dispatch("follow/getFollowUser", data);
      this.listFollow = result.list;
      this.totalPages = result.totalPages;
      this.currentPage = result.currentPage;
      if (result.totalPages == result.currentPage) {
        this.endData = true;
      }
    },
  },
  mounted() {
    this.getSubscription();
  },
};
</script>

<style lang="scss">
.boxRelative {
  position: relative;
  display: flex;
  align-items: center;
  .boxRelative-name {
    flex: auto;
  }
}
.customBtn {
  justify-self: end;
}
</style>
